const visitorUrl: Record<string, string> = {
  prod: 'https://visitor.alta.avigilon.com',
  prodeu1: 'https://visitor.eu.alta.avigilon.com',
  dev: 'https://visitor.dev.alta.avigilon.com',
  sandbox: 'https://visitor.sandbox.alta.avigilon.com',
  mine: 'http://localhost:3000/visitor',
  test: 'https://visitor.test.alta.avigilon.com',
};

export const getVisitorUrl = (region: OP.Env): string => {
  return `${visitorUrl[region]}`;
};
